import { useEffect, useRef, useState } from 'react';
import { Howl } from 'howler';

// Base64 encoded small click sound
const clickSoundBase64 = 'data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4Ljc2LjEwMAAAAAAAAAAAAAAA/+M4wAAAAAAAAAAAAFhpbmcAAAAPAAAAAwAAA3gAlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaWlpaW8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw////////////////////////////////////////////AAAAAExhdmM1OC4xMwAAAAAAAAAAAAAAACQCgAAAAAAAAANwxaLqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+MYxAAAAANIAAAAAExBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV/+MYxDsAAANIAAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV/+MYxHYAAANIAAAAAFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV';

const useSound = () => {
  const [soundsInitialized, setSoundsInitialized] = useState(false);
  const clickSoundRef = useRef<Howl | null>(null);
  const hoverSoundRef = useRef<Howl | null>(null);
  const typingSoundRef = useRef<Howl | null>(null);
  
  useEffect(() => {
    // Add a listener for user interaction to initialize sounds
    const initializeSounds = () => {
      if (soundsInitialized) return;

      // Initialize sounds
      clickSoundRef.current = new Howl({
        src: [clickSoundBase64],
        volume: 0.5,
        preload: true
      });
      
      hoverSoundRef.current = new Howl({
        src: [clickSoundBase64], // Use the same sound but lower volume
        volume: 0.2,
        preload: true
      });
      
      typingSoundRef.current = new Howl({
        src: [clickSoundBase64], // Use the same sound but even lower volume
        volume: 0.1,
        preload: true
      });

      setSoundsInitialized(true);
      
      // Remove the event listeners once initialized
      document.removeEventListener('click', initializeSounds);
      document.removeEventListener('touchstart', initializeSounds);
    };

    document.addEventListener('click', initializeSounds);
    document.addEventListener('touchstart', initializeSounds);
    
    return () => {
      // Clean up
      document.removeEventListener('click', initializeSounds);
      document.removeEventListener('touchstart', initializeSounds);
      
      clickSoundRef.current?.unload();
      hoverSoundRef.current?.unload();
      typingSoundRef.current?.unload();
    };
  }, [soundsInitialized]);
  
  const playClick = () => {
    if (clickSoundRef.current) {
      clickSoundRef.current.play();
    }
  };
  
  const playHover = () => {
    if (hoverSoundRef.current) {
      hoverSoundRef.current.play();
    }
  };
  
  const playTyping = () => {
    if (typingSoundRef.current) {
      typingSoundRef.current.play();
    }
  };
  
  return { playClick, playHover, playTyping };
};

export default useSound;